import React from "react";
import SectionComponent from "components/common/Section/SectionComponent";
import { useTranslation } from "react-i18next";
import UserCollections from "./UserCollections";
const UserCollectionsSection = ({ user }) => {
  const { t } = useTranslation("enterprise_collections");
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: t("shared.collections") }, /* @__PURE__ */ React.createElement(UserCollections, { userId: user.id }));
};
export default UserCollectionsSection;
